import React, { useState } from 'react';
import { Menu, MenuIcon, User, XIcon } from 'lucide-react';
import { Avatar, Button, Drawer, Space } from 'antd';
import LogoutModal from '../AppModal/LogoutModal';
import Sider from '../Sider';
import useUser from '@/redux/hooks/useUser';
import { CloseOutlined, LogoutOutlined } from '@ant-design/icons';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { Link } from 'react-router-dom';
import PATH from '@/config/paths/PATH';

function HeaderMobile({ items }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const {
    user: { fullname },
  } = useUser();

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <div className="flex items-center justify-between w-full h-full">
      {/* <div className="logo flex items-center justify-start flex-row gap-2 h-full">
        <img src="/logo.png" alt="Magic Wheel" className="aspect-auto w-20 h-auto" />
      </div> */}
      <div onClick={handleOpenDrawer}>
        <MenuIcon size={20} />
      </div>

      <Space className="flex items-center justify-end">
        <div>
          <span className="font-semibold">Hello, </span>
          {fullname}
        </div>
        <Avatar icon={<User />} className="mb-1" />
        {/* <img src="/logo.png" alt="Magic Wheel" className="aspect-auto w-20 h-auto" /> */}
      </Space>

      <Drawer
        placement="left"
        open={openDrawer}
        // closable
        closeIcon={false}
        onClose={handleCloseDrawer}
        className="flex"
        width={isMobile ? '100%' : '50%'}
        title={
          <Space className="flex items-center justify-between">
            <Link to={PATH.HOME} onClick={handleCloseDrawer}>
              <img src="/logo.png" alt="Magic Wheel" className="aspect-auto w-20 h-auto" />
            </Link>
            <Button onClick={handleCloseDrawer} type="text" icon={<CloseOutlined />} />
          </Space>
        }
        footer={
          <div className="w-full">
            <Button
              icon={<LogoutOutlined />}
              onClick={() => {
                setOpenModal(true);
              }}
              className="w-full"
              color="danger"
              variant="filled"
            >
              Sign out
            </Button>
          </div>
        }
      >
        <div className="pb-6">
          <Sider
            theme="light"
            items={items}
            isMobile
            handleCloseDrawer={handleCloseDrawer}
            openDrawer={openDrawer}
          />
        </div>
      </Drawer>

      <LogoutModal openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
}

export default HeaderMobile;
